/*
    This mixin only check if component has methods validate and back as they are needed for StepNavigation.vue
 */
export default {
    created() {
        if (!this.hasOwnProperty('validate') || !this.hasOwnProperty('back') ) {
            throw 'You should implement "validate" and "back" for a StepComponent in ' + this.$options.name;
        }
    },
};